// extracted by mini-css-extract-plugin
export default {"removeBtnBox":"RemoveIcon_removeBtnBox__D2coh","charges":"RemoveIcon_charges__GASwT","icon":"RemoveIcon_icon__h09OR"};